import { render, staticRenderFns } from "./AppLocalization.vue?vue&type=template&id=3a808112"
import script from "./AppLocalization.vue?vue&type=script&lang=js"
export * from "./AppLocalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports